import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';

import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { useDropdown } from 'core/hooks/useDropdown';

import { triggerPsrApplyFilterGaEvent } from 'core/modules/ProductSearchResults/actions';

function FilterDesktop({ title, facet, filterHook }) {
  const dispatch = useDispatch();
  const filterRef = useRef();
  const { showSubnav, isFocused } = useDropdown(filterRef);
  const { toggleIdInFilter, checkIsIdAddedToFilter } = filterHook;
  const filterTitle = title || facet.label;

  const handleOnToggleIdChange = (facetName, id) => {
    toggleIdInFilter(facetName, id);

    const isAddedToFilter = !checkIsIdAddedToFilter(facetName, id);
    dispatch(triggerPsrApplyFilterGaEvent(facetName, isAddedToFilter));
  };

  return (
    <div ref={filterRef} className={`mn_filterWrap mn_${facet.name}`}>
      <button
        className="mn_filterButton"
        onClick={showSubnav}
        aria-expanded={isFocused}
        aria-label={`Opens filter by ${filterTitle} list`}
      >
        {filterTitle}
      </button>
      { isFocused &&
        <div className="mn_filterDropdown">
          <div className="mn_filterDropdownTitle">{filterTitle}</div>
          <ul>
            {facet.values.map(({ id, label }) => (
              <li key={id}>
                <label>
                  <input
                    type="checkbox"
                    onChange={() => handleOnToggleIdChange(facet.name, id)}
                    checked={checkIsIdAddedToFilter(facet.name, id)}
                  />
                  <span className="mn_name">{label}</span>
                </label>
              </li>
            ))}
          </ul>
        </div>
      }
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><FilterDesktop {...props} /></ComponentErrorBoundary>;
